import React, { createContext, useContext } from 'react'; // eslint-disable-line
import { Shop } from '../interfaces';

interface ShopContent {
  shop: Shop | null;
}

export const ShopContext = createContext<ShopContent>({
  shop: null,
});

export const useShopContext = () => useContext(ShopContext);
